<template>
  <LoadingAnimation v-if="!loadingComplete" @loading-complete="onLoadingComplete" />
  <div v-show="loadingComplete" class="app-wrapper">
    <NavBar :class="{ 'slide-down': showContent }" />
    <div class="app-content" :class="{ 'fade-in': showContent }">
      <HelloWorld msg="" :class="{ 'slide-up': showContent }"/>
    </div>
    <AppFooter :class="{ 'slide-up': showContent }" />
    <GoToTop />
  </div>
</template>

<script>
import HelloWorld from './components/HelloWorld.vue'
import LoadingAnimation from './components/LoadingAnimation.vue'
import NavBar from './components/NavBar.vue'
import AppFooter from './components/Footer.vue'
import GoToTop from './components/GoToTop.vue'

export default {
  name: 'App',
  components: {
    HelloWorld,
    LoadingAnimation,
    NavBar,
    AppFooter,
    GoToTop
  },
  data() {
    return {
      loadingComplete: false,
      showContent: false
    }
  },
  methods: {
    onLoadingComplete() {
      this.loadingComplete = true;
      // 添加一个小延迟，确保DOM已经更新
      setTimeout(() => {
        this.showContent = true;
      }, 100);
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.app-wrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 1;
}

.app-wrapper::before {
  content: '';
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: 
    radial-gradient(circle at 25% 25%, rgba(255, 215, 0, 0.03) 0%, transparent 50%),
    radial-gradient(circle at 75% 75%, rgba(17, 24, 85, 0.03) 0%, transparent 50%);
  z-index: -1;
}

.app-content {
  margin-top: 60px;
  padding: 20px;
  flex: 1;
  opacity: 0;
  transition: opacity 0.8s ease-out;
}

.app-content.fade-in {
  opacity: 1;
}

.slide-down {
  transform: translateY(-50px);
  opacity: 0;
  transition: all 0.8s ease-out;
}

.navbar.slide-down {
  transform: translateY(0);
  opacity: 1;
}

.slide-up {
  transform: translateY(30px);
  opacity: 0;
  transition: all 0.8s ease-out;
}

.hello.slide-up, .footer.slide-up {
  transform: translateY(0);
  opacity: 1;
}

/* 组件延迟动画 */
.hello.slide-up {
  transition-delay: 0.5s;
}

.footer.slide-up {
  transition-delay: 0.7s;
}

body {
  margin: 0;
  padding: 0;
  overflow-x: hidden;
  background-color: #f8f9fa;
  background-image: 
    linear-gradient(to bottom, rgba(255,255,255,0.8) 0%, rgba(248,249,250,1) 100%),
    url("data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM34 90c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm56-76c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM12 86c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm28-65c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm23-11c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-6 60c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm29 22c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zM32 63c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm57-13c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-9-21c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM60 91c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM35 41c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM12 60c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2z' fill='%23111855' fill-opacity='0.03' fill-rule='evenodd'/%3E%3C/svg%3E");
}

/* 添加滚动条美化 */
::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb {
  background: linear-gradient(to bottom, rgba(17, 24, 85, 0.5), rgba(255, 215, 0, 0.5));
  border-radius: 10px;
}

::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(to bottom, rgba(17, 24, 85, 0.7), rgba(255, 215, 0, 0.7));
}
</style>
